import { gql } from "../../../../../gql/__generated__/gql";

export const CHECK_FOR_EXISTING_USER = gql(`
  query checkForExistingUser($email: String!) {
    checkForExistingUser(email: $email) {
      exists
      validated
    }
  }
`);

export const GET_ALL_CREATORS = gql(`
  query creators {
    creators {
      email
      userType
      validated
      createdAt
      updatedAt
      name
      description
      tiktokData {
        openId
        scope
        userInfo {
          avatar_large_url
          avatar_url
          bio_description
          display_name
          follower_count
          following_count
          is_verified
          likes_count
          open_id
          profile_deep_link
          union_id
          username
          video_count
        }
      }
      imageUrl
      brandId
      rating
      categories
      monthlyGMV
      socialMedia {
        tiktok
        instagram
        youtube
        twitter
      }
    }
  }
`);

export const GET_USER = gql(`
  query user($email: String!) {
    user(email: $email) {
    email
    userType
    validated
    createdAt
    updatedAt
    name
    description
    tiktokData {
      accessToken
      openId
      refreshToken
      refreshTokenExpiry
      scope
      tokenExpiry
      userInfo {
        avatar_large_url
        avatar_url
        bio_description
        display_name
        follower_count
        following_count
        is_verified
        likes_count
        open_id
        profile_deep_link
        union_id
        username
        video_count
      }
    }
    imageUrl
    brandId
    rating
    completedCollabs
    categories
    monthlyGMV
    socialMedia {
      tiktok
      instagram
      youtube
      twitter
    }
  }
  }
`);

export const LOGIN_USER = gql(`
  query loginUser($email: String!, $password: String!) {
    loginUser(password: $password, email: $email)
  }
`);

// export const REFRESH_TOKEN = gql(`
//   query refreshToken {
//     refreshToken
//   }
// `);
